import {
  GET_FUND_HISTORICAL_POSITION_REQUEST,
  GET_FUND_HISTORICAL_POSITION_SUCCESS,
  GET_FUND_HISTORICAL_POSITION_FAILURE,
  statusType
} from '../../../actions'

const initial = {
  data: null,
  status: statusType.IDLE
}

const fundHistoricalPositionReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_FUND_HISTORICAL_POSITION_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_FUND_HISTORICAL_POSITION_SUCCESS:
      return {
        data: action.payload,
        status: statusType.SUCCESS
      }

    case GET_FUND_HISTORICAL_POSITION_FAILURE:
      return {
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default fundHistoricalPositionReducer
